module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Italic.426029c.woff";